import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { stroke: "currentColor" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.351 1.553a1 1 0 0 1 1.298 0l1.86 1.585a1 1 0 0 0 .569.236l2.437.194a1 1 0 0 1 .917.918l.194 2.436a1 1 0 0 0 .236.57l1.585 1.86a1 1 0 0 1 0 1.297l-1.585 1.86a1 1 0 0 0-.236.569l-.194 2.437a1 1 0 0 1-.917.917l-2.437.194a1 1 0 0 0-.57.236l-1.86 1.585a1 1 0 0 1-1.297 0l-1.86-1.585a1 1 0 0 0-.569-.236l-2.436-.194a1 1 0 0 1-.918-.917l-.194-2.437a1 1 0 0 0-.236-.57l-1.585-1.86a1 1 0 0 1 0-1.297l1.585-1.86a1 1 0 0 0 .236-.569l.194-2.436a1 1 0 0 1 .918-.918l2.436-.194a1 1 0 0 0 .57-.236l1.86-1.585Z" }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m7 13 6-6M8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }